function Footer() {
  return (
    <footer>
      <h1>inquiries/contact</h1>
      <p>cdsherrardjr@gmail.com</p>
      <p>
        <a href="https://www.instagram.com/cds__j">instagram</a> <a href="https://github.com/cds-j" target="_blank" rel="noreferrer">github</a>
      </p>
    </footer>
  )
}

export default Footer;